<template>
  <div class="cMenu" :style="{ 'min-height': height + 'px' }">
    <el-menu
      :default-active="defaultActive"
      class="el-menu-vertical-demo"
      active-text-color="#266CEE"
      @select="handleSelect"
    >
      <div v-for="(item, index) in menuData" :key="index">
        <el-menu-item
          :index="item.permissionCode"
          v-if="!item.contentPermissionDTOs.length"
        >
          <img class="el-menu-icon" :src="baseImgUrl + item.iconUrl" alt="" />
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
        <el-submenu :index="item.permissionCode" v-else>
          <template slot="title">
            <img
              class="el-menu-icon"
              :src="
                app_type == 'admin'
                  ? '/img/admin/menu_sys_manage.svg'
                  : baseImgUrl + item.iconUrl
              "
              alt=""
            />
            <span>{{ item.name }}</span>
          </template>
          <el-menu-item-group
            v-for="(subItem, subIndex) in item.contentPermissionDTOs"
            :key="subIndex"
          >
            <!-- 内容营销 start -->
            <el-menu-item
              :index="subItem.permissionCode"
              v-if="subItem.permissionCode === 'man_activity_manage'"
            >
              <a
                slot="title"
                :href="`${marketSystemUrl}${subItem.url}?tenantId=${tenantId}&source=content&logintype=${logintype}`"
                target="_blank"
                rel="noreferrer"
                >{{ subItem.name }}</a
              >
            </el-menu-item>
            <!-- 内容营销 end -->
            <el-menu-item :index="subItem.permissionCode" v-else>
              {{ subItem.name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { listContentUserPermissions } from "../api/user";
import { getPremissionList } from "../api/admin";
import { listContentUserManPermissions } from "../api/man";
import { mapState, mapMutations } from "vuex";
import { routes as adminRoutes } from "../entrys/admin/router/index.js";
import { routes as userRoutes } from "../entrys/user/router/index.js";
import { routes as manRoutes } from "../entrys/man/router/index.js";
import { getQueryString } from "../utils/tools";

var app_type = process.env.VUE_APP_TYPE;
var routeQueryMap = {};
function findRouteInFullRouteTable(url, routes, parentRoute, matched) {
  for (var i = 0; i < routes.length; i++) {
    var route = routes[i];
    if (parentRoute) {
      route.parentRoute = parentRoute;
    }
    if (route.children && route.children.length > 0) {
      var route1 = findRouteInFullRouteTable(
        url,
        route.children,
        route,
        matched
      );
      if (route1) {
        return route1;
      }
    }
    if (route.path == url) {
      return route;
    }
    if (matched.regex.test(route.path)) {
      // 动态路由的话返回path为实际path
      return {
        ...route,
        // path: url,
      };
    }
  }
  return null;
}
function getBreadArrayByRoute(route, breadArray) {
  if (route.meta) {
    var title = route.meta.title;
    breadArray.unshift({
      path: route.meta.isMenu === false ? "" : route.path,
      name:
        typeof title == "function" ? title(routeQueryMap[route.path]) : title,
      query: routeQueryMap[route.path],
    });
    if (route.meta.upMenuTitle) {
      for (var i = route.meta.upMenuTitle.length - 1; i > -1; i--) {
        var title = route.meta.upMenuTitle[i].title;
        breadArray.unshift({
          path:
            route.meta.upMenuTitle[i].isMenu === false
              ? ""
              : route.meta.upMenuTitle[i].url,
          name:
            typeof title == "function"
              ? title(routeQueryMap[route.path])
              : title,
          query: routeQueryMap[route.meta.upMenuTitle[i].url],
        });
      }
    }
  }
  if (route.parentRoute) {
    getBreadArrayByRoute(route.parentRoute, breadArray);
  }
}

// import { routes } from "../../router";

export default {
  name: "cMenu",
  data() {
    return {
      // 内容营销地址
      marketSystemUrl: process.env.VUE_APP_MARKET_URL,
      tenantId: getQueryString("tenantid") || process.env.VUE_APP_TENANTID,
      logintype: "",
      // 是否有内容营销菜单权限
      marketMenuPermission: false,
      baseImgUrl: "//image.healthjd.com/da/",
      menuData: [],
      // 全路由表
      allMenuData: [],
      defaultActive: "1",
      height: "",
      app_type,
      currMenu: "",
      breadArrayStore: [],
    };
  },
  computed: {
    ...mapState(["breadArray"]),
  },
  watch: {
    $route(to, from) {
      this.setBreadArray([]);
      this.handleMenu();
    },
  },
  created() {
    this.height =
      (window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight) - 70;
    window.onresize = () => {
      this.height =
        (window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight) - 70;
    };
  },
  mounted() {
    this.init();
    this.logintype = window.sessionStorage.getItem("logintype");
  },
  methods: {
    ...mapMutations([
      "setBreadArray",
      "setBreadArrayCas",
      "setBreadArrayIndex",
    ]),

    getRoutePath(path) {
      return path.charAt(path.length - 1) == "/"
        ? path.substring(0, path.length - 1)
        : path;
    },
    async init() {
      let res = "";
      if (process.env.VUE_APP_TYPE == "user") {
        res = await listContentUserPermissions({
          tenantId: this.$commonJs.getTenantId(),
        });
        this.allMenuData = this.$commonJs.deepClone(userRoutes);
      } else if (process.env.VUE_APP_TYPE == "admin") {
        res = await getPremissionList();
        this.allMenuData = this.$commonJs.deepClone(adminRoutes);
      } else if (process.env.VUE_APP_TYPE == "man") {
        res = await listContentUserManPermissions({
          tenantId: this.$commonJs.getTenantId(),
        });
        this.allMenuData = this.$commonJs.deepClone(manRoutes);
      }
      this.menuData = res || [];

      this.handleMenu();
    },
    handleMenu() {
      var currPath = this.getRoutePath(this.$route.path);
      const matched = this.$route.matched.find(
        (item) => item.name === this.$route.name
      );
      console.log(44444, this.$route, this.$router);
      // console.log(routes);
      this.menuData.forEach((item, index) => {
        let subArray =
          (item.contentPermissionDTOs && item.contentPermissionDTOs) || [];
        if (!subArray.length) {
          //一级菜单
          let url = item.url;
          if (url == currPath) {
            console.log(item.permissionCode);
            this.currMenu = item.url;
            this.breadArrayStore.push({
              name: item.name,
              path: "",
              query: null,
            });
            this.defaultActive = item.permissionCode;
          }
        } else {
          //二级菜单
          subArray.forEach((target) => {
            let url = target.url;
            if (url == currPath) {
              this.currMenu = url;
              // 标签存储数据
              if (
                target.permissionCode === "man_label_common_manage" ||
                target.permissionCode === "man_label_bus_manage"
              ) {
                if (
                  !this.breadArrayStore.some(
                    (item) => item.path === this.$route.path
                  )
                ) {
                  if (!this.$route.query.breadpath)
                    routeQueryMap[currPath] = this.$route.query;
                  const route = findRouteInFullRouteTable(
                    currPath,
                    this.allMenuData,
                    null,
                    matched
                  );
                  // console.log(findRouteInFullRouteTable(currPath, this.allMenuData, null, matched), 999);
                  var breadArray = [];
                  route && getBreadArrayByRoute(route, breadArray);
                  this.breadArrayStore = breadArray;
                  // this.setSessionStorage();
                  this.setBreadArrayCas(this.breadArrayStore);
                }
              } else if (target.url === "/indexManage/group") {
                if (
                  !this.breadArrayStore.some(
                    (item) => item.path === this.$route.path
                  )
                ) {
                  if (!this.$route.query.breadpath)
                    routeQueryMap[currPath] = this.$route.query;
                  const route = findRouteInFullRouteTable(
                    currPath,
                    this.allMenuData,
                    null,
                    matched
                  );
                  // console.log(findRouteInFullRouteTable(currPath, this.allMenuData, null, matched), 999);
                  var breadIndex = [];
                  route && getBreadArrayByRoute(route, breadIndex);
                  this.breadArrayStore = breadIndex;
                  // this.setSessionStorage();
                  this.setBreadArrayIndex(this.breadArrayStore);
                }
              }
              this.defaultActive = target.permissionCode;
            }
          });
        }
      });
      /*var isExisted = false;
        this.menuData.forEach((item,index)=>{
          let subArray=item.contentPermissionDTOs&&item.contentPermissionDTOs||[];
          if(!subArray.length){
            //一级菜单
            let url = item.url;
            if(url==this.$route.path){
             this.defaultActive=item.permissionCode;
             this.setBreadArray([{
               path: url,
               name:item.name
             }])
             isExisted = true;
            }
          }else{
            //二级菜单
            subArray.forEach(target=>{
              let url= target.url;
              if(url==this.$route.path){
                this.setBreadArray([{
                  path:'',
                  name:item.name
                },{
                  path:url,
                  name:target.name
                }]);
                this.defaultActive=target.permissionCode;
                isExisted = true;
              }
            })
          }
        })
        // 如果非菜单链接，则在全路由表中获取面包屑
        if(!isExisted){*/
      var route = findRouteInFullRouteTable(
        currPath,
        this.allMenuData,
        null,
        matched
      );

      if (!this.$route.query.breadpath)
        routeQueryMap[currPath] = this.$route.query;
      var breadArray = [];
      route && getBreadArrayByRoute(route, breadArray);
      this.setBreadArray(breadArray);
      //}
    },
    handleSelect(index, indexPath) {
      $("#account_type_error_123").remove();
      this.handleMenu();
      let item = this.menuData.filter((item, index) => {
        if (item.permissionCode == indexPath[0]) {
          // && item.permissionGroup == 1
          return item;
        }
      });
      let subArray = item[0].contentPermissionDTOs;
      let firstMenuUrl = item[0].url;
      if (!subArray.length) {
        // -------------- 内容营销 start -------------------
        if (["man_content_config"].indexOf(item[0].permissionCode) > -1) {
          return;
        }
        // -------------- 内容营销 end -------------------
        //一级菜单
        this.$router.push({
          path: firstMenuUrl,
          query: {
            t: Date.now(),
          },
        });
        this.defaultActive = item[0].permissionCode;
      } else {
        subArray = item[0].contentPermissionDTOs.filter((i) => {
          return i.permissionCode == indexPath[1]; // && i.permissionGroup == 1
        });
        // -------------- 内容营销 start -------------------
        if (["man_activity_manage"].indexOf(subArray[0].permissionCode) > -1) {
          return;
        }
        // -------------- 内容营销 end -------------------
        let elseUrl = subArray[0].url;
        this.$router.push({
          path: elseUrl,
          query: {
            t: Date.now(),
          },
        });
        this.defaultActive = subArray[0].permissionCode;
      }
      /*let breadArray=[];
        let item=this.menuData.filter((item,index)=>{
          if(item.permissionCode==indexPath[0]){// && item.permissionGroup == 1
            return item;
          }
        });
        let subArray=item[0].contentPermissionDTOs;
        let firstMenuUrl = item[0].url
        if(!subArray.length){
          //一级菜单
          this.$router.push({
            path: firstMenuUrl
          })
          this.defaultActive=item[0].permissionCode;
          breadArray.push({
            path: firstMenuUrl,
            name:item[0].name
          })
        }else{
          subArray=item[0].contentPermissionDTOs.filter((i)=>{
            return i.permissionCode==indexPath[1];// && i.permissionGroup == 1
          });
          let elseUrl = subArray[0].url
          this.$router.push({
            path: elseUrl
          })
          this.defaultActive=subArray[0].permissionCode;
          breadArray.push({
            path: firstMenuUrl,
            name:item[0].name
          },{
            path: elseUrl,
            name:subArray[0].name
          })
        }
        this.setBreadArray(breadArray)*/
    },
  },
};
</script>

<style scoped lang="scss">
.cMenu {
  width: 180px;
  flex-shrink: 0;
  /*height: 100%;*/
  background: white;
  .el-menu-item {
    height: 50px;
    line-height: 50px;
  }
  .el-menu-icon {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  :deep(.el-submenu) {
    .el-submenu__title {
      height: 50px;
      line-height: 50px;
    }
    .el-menu-item-group__title {
      display: none;
    }
    .el-menu-item {
      width: 100%;
      box-sizing: border-box;
      padding: 0 0 0 46px !important;
      min-width: 100% !important;
    }
  }
  :deep(.el-threemenu) {
    .el-submenu__title {
      padding-left: 46px !important;
    }
  }
}
</style>
